/**
 * @description Translation key explaining who set an applicant status, for the actor dot / badge tooltip.
 * Bestie (automation, `auto`), the account manager logged in from admin (`admin`), or the account's own recruiters
 * (`owner`, any recruiter on the account — the backend doesn't tell them apart).
 * @param actor - `statusChangeActor` ('auto' | 'admin' | 'owner')
 * @param isShortlist - Shortlist keeps its own "Shortlisted by…" wording (Bestie / account manager only)
 */
export const getStatusSourceLabelKey = (actor: string | null | undefined, isShortlist: boolean): string | undefined => {
  if (actor === 'auto') return isShortlist ? 'shortlisted_source_bestie' : 'status_source_bestie';
  if (actor === 'admin') return isShortlist ? 'shortlisted_source_agent' : 'status_source_agent';
  if (actor === 'owner') return 'status_source_owner';
  return undefined;
};
